import { useMemo } from 'react'

import { useController, useFormContext } from 'react-hook-form'

import { TextField } from '@/components/ui/text-field'
import type { QuestionnaireFormValues } from '@/modules/questionnaire/types'

import { Field } from '../../components/field'
import { PhoneNumberInput } from '../../components/phone-number-input/PhoneNumberInput'

interface Props {
  type: QuestionnaireFormValues['preferredCommunication']
}

const labels: Record<
  QuestionnaireFormValues['preferredCommunication'],
  string
> = {
  WhatsApp: 'WhatsApp number',
  Telegram: 'Telegram account',
}

export const PreferredCommunicationSpecifier = ({ type }: Props) => {
  const { control } = useFormContext<QuestionnaireFormValues>()
  const {
    field: { onChange, value },
  } = useController({ control, name: type })

  const input = useMemo(() => {
    switch (type) {
      case 'WhatsApp':
        return (
          <PhoneNumberInput
            value={value}
            onChange={onChange}
          />
        )
      case 'Telegram':
        return (
          <TextField
            value={value}
            onChange={onChange}
            prefix="@"
            showPrefixSeparator
          />
        )
      default:
        return null
    }
  }, [type, value, onChange])

  return (
    <Field
      label={labels[type]}
      isRequired
    >
      {input}
    </Field>
  )
}
